<template>
  <SpecialistsList />
</template>

<script>
import SpecialistsList from "@/components/Specialists/SpecialistsList"
export default {
  name: "Specialists",
  components: {
    SpecialistsList
  },
};
</script>

<style lang="sass"></style>
